module.exports = __webpack_public_path__ + "static/media/definite.0587794a.mp3";